import { HttpErrorResponse } from '@angular/common/http';

const MAX_CONTENTION_ATTEMPTS = 3;

export class AutoCodeUtilities {

  static isContention(error: unknown): boolean {
    const response = error as HttpErrorResponse;
    return response?.status === 409 && response?.error?.autoCodeError === 'AUTO_CODE_CONTENTION';
  }

  static isAutoCodeError(error: unknown): boolean {
    const response = error as HttpErrorResponse;
    return Boolean(response?.error?.autoCodeError)
      || (response?.status === 403 && response?.error?.message === 'Invalid registering company');
  }

  static isDuplicatedLaborCode(error: unknown): boolean {
    const response = error as HttpErrorResponse;
    return response?.status === 400 && response?.error?.message === 'Duplicated labor code';
  }

  static async retryOnContention<T>(action: () => Promise<T>, maxAttempts = MAX_CONTENTION_ATTEMPTS): Promise<T> {
    for (let attempt = 1; ; attempt++) {
      try {
        return await action();
      } catch (error) {
        if (attempt >= maxAttempts || !AutoCodeUtilities.isContention(error)) {
          throw error;
        }
      }
    }
  }
}
